import { HttpClient, HttpErrorResponse, HttpEvent, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { EventEmitter, Injectable, Input, NgZone, Output } from '@angular/core';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { FilePath } from '@ionic-native/file-path';
import { FileTransfer, FileTransferObject, FileUploadOptions } from '@ionic-native/file-transfer';
import { ILocalNotification, LocalNotifications } from '@ionic-native/local-notifications';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import saveAs from 'file-saver';
import { Platform, AlertController } from 'ionic-angular';
import * as moment from 'moment/moment';
import { CompanyBloc } from '../../bloc/company/company.bloc';
import { PermissionCheckProvider } from '../permission-check/permission-check';
import { StoragePathProvider } from '../storage-path/storage-path';
import { ToastServiceProvider } from '../toast-service/toast.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, Observer } from 'rxjs';
import { Messages } from '../../helpers/messages';
import { InAppBrowser } from '@ionic-native/in-app-browser';
declare var window;
/*
  Generated class for the GlobalServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GlobalServiceProvider {


  //Parse Variable From Color Picker to ID Card Template
  @Input() selectedColor: any;
  @Output() customColor: EventEmitter<any> = new EventEmitter();
  @Output() showColorPicker: EventEmitter<boolean> = new EventEmitter();

  private win: any = window;
  public timeout = 30000;
  public percentageProgress: number = 0;
  public languageList = [
    {
      value: 'en',
      text: 'English',
      locale: 'en'
    },
    {
      value: 'id',
      text: 'Indonesia',
      locale: 'id'
    },
    {
      value: 'th',
      text: 'Thailand',
      locale: 'th'
    },
    {
      value: 'cn',
      text: 'Chinese',
      locale: 'zh'
    },
    {
      value: 'kr',
      text: 'Korean',
      locale: 'ko_KR'
    },
    {
      value: 'jp',
      text: 'Japanese',
      locale: 'ja'
    },
    {
      value: 'my',
      text: 'Malaysia',
      locale: 'ms'
    },
    {
      value: "vn",
      text: "Vietnam",
      locale: "vi",
    },
  ]

  private isFromLogin: boolean = false;
  private isGooglePlayServicesAvailable: boolean = true;
  private isGoogleMapsAvailable: boolean = true;

  constructor(
    public http: HttpClient,
    public platform: Platform,
    public transfer: FileTransfer,
    public permissionCheck: PermissionCheckProvider,
    public storagePathProvider: StoragePathProvider,
    public file: File,
    public fileOpener: FileOpener,
    public toastService: ToastServiceProvider,
    public storage: Storage,
    public localNotifications: LocalNotifications,
    public translate: TranslateService,
    public filePath: FilePath,
    public ngZone: NgZone,
    public companyBloc: CompanyBloc,
    private sanitizer: DomSanitizer,
    private alertCtrl: AlertController,
    private inAppBrowser: InAppBrowser
  ) {

  }

  setRouteFromLogin(value: boolean = false) {
    this.isFromLogin = value;
  }

  checkRouteFromLogin() {
    return this.isFromLogin;
  }

  /**
   * Handle menampilkan gambar pakai styling background-image
   * @param image 
   */
  pathImage(image) {
    if (this.platform.is('cordova')) {
      // handle new version wkWebView version >= 3
      if (this.platform.is('android')) {
        try {
          return this.win.Ionic.WebView.convertFileSrc(image);
        } catch (error) {
          return image;
        }
      }
      else if (this.platform.is('ios')) {
        return this.win.Ionic.WebView.convertFileSrc(image)
      }
    }
    else {
      return image;
    }
  }

  /**
   * Handle menampilkan gambar pakai tag <img [src]="">
   * @param image 
   */
  imageResourceUrl(image) {
    if (this.platform.is('cordova')) {
      // handle new version wkWebView version >= 3
      if (this.platform.is('android')) {
        try {
          return this.win.Ionic.WebView.convertFileSrc(image);
        } catch (error) {
          return image;
        }
      }
      else if (this.platform.is('ios')) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.win.Ionic.WebView.convertFileSrc(image))
      }
    }
    else {
      return image;
    }
  }


  convertFileToBase64(file: Blob): Promise<any> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        // called once readAsDataURL is completed
        let base64 = event.target.result;
        resolve(base64);
      }
      reader.readAsDataURL(file);
    });
  }

  convertUriToFile(path: string, fileName: string, type: string = 'jpg'): Promise<any> {
    return new Promise(async (resolve) => {
      await this.platform.ready();
      const mimeType = this.getMIMEtype(type);
      this.file.readAsArrayBuffer(path, fileName).then((result) => {
        let blob = new Blob([result], { type: mimeType });
        resolve(blob);
      }).catch((err) => {
        resolve(err);
      })
    });
  }

  convertDataURItoBlob(dataURI) {
    var binary = this.win.atob(dataURI.split(',')[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    return new Blob([new Uint8Array(array)], {
      type: 'image/jpg'
    });
  }

  convertBase64toBlob(dataURI) {
    return new Promise((resolve) => {
      let byteString = atob(dataURI.split(',')[1]);
      let ab = new ArrayBuffer(byteString.length);
      let ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([ab], { type: 'image/jpeg' });
      resolve(blob)
    })
  }

  getBase64ImageFromURL(url: string): Observable<any> {
    return Observable.create((observer: Observer<string>) => {
      let img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      if (!img.complete) {
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = (err) => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  getBase64Image(img: HTMLImageElement) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  async download(urlDownload, pathDestination): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.platform.is('cordova')) {
        const fileTransfer: FileTransferObject = this.transfer.create();
        fileTransfer.download(urlDownload, pathDestination, true)
          .then((entry) => {
            let filePath: string = this.pathImage(entry.toURL());
            let origin = entry.toURL();

            let data = { origin: origin, url: filePath }
            resolve(data);
          }, (error) => {
            reject(error);
          });
      }
      else {
        resolve(false);
      }
    })
  }

  splashScreenDownload(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        const result = await this.storage.get('SFGoAuth');
        const response = JSON.parse(result);
        let companyApi: any = {};
        let companyLog = '';
        try {
          companyApi = {
            companyName: response.company.companyName,
            taxcountry: response.company.taxcountry,
            companyLogo: response.company.companyLogo
          }
          companyLog = response.company.companyLogo;
        } catch (error) {
          companyApi = await this.companyBloc.getCompany(response.companyId);
          companyLog = companyApi.companyLogo;
        }

        await this.storage.set('company', JSON.stringify(companyApi));

        await this.permissionCheck.setPathDownload();
        const company = await this.storagePathProvider.getStorageCompanyProfile();
        const urlDownload = company.urlDownload + companyLog;

        // for dynamic logo company splashscreen
        const pathDestination = this.file.dataDirectory + 'GreatDayHr/logo-company.jpg';
        this.download(urlDownload, pathDestination).then((result) => {
          if (result) {
            localStorage.setItem('splashscreen', JSON.stringify(result));
          }
        });
        resolve(true);
      } catch (error) {
        resolve(true);
      }
    })
  }

  uploadFile(url, file, accessToken?: any, imageOnly: boolean = false): Promise<any> {
    console.log('url upload', url);
    return new Promise((resolve) => {
      let result = { fileName: '' };
      if (this.platform.is('cordova')) {
        let options: FileUploadOptions = {
          fileKey: 'file',
          chunkedMode: false,
          mimeType: imageOnly == false ? "multipart/form-data" : "image/jpg",
        };

        if (imageOnly) {
          options.fileName = moment().valueOf() + '.jpg';
        }

        const fileTransfer: FileTransferObject = this.transfer.create();
        // Bind the progress function
        fileTransfer.onProgress(this.onProgress);

        fileTransfer.upload(file, url, options).then((res: any) => {
          const response = JSON.parse(res.response);
          result.fileName = response.hasOwnProperty('data') && response.data ? response.data.fileName : response.result.files.file[0].name;
          console.log(res);
          resolve(result);
        }).catch((err) => {
          console.log('error upload', err);
          resolve(false)
        })
      }
      else {
        let headerOptions = new HttpHeaders().set('Authorization', accessToken);
        const formData = new FormData();

        if (imageOnly) {
          formData.append('file', file, moment().valueOf() + '.jpg');
        }
        else {
          formData.append('file', file);
        }

        const req = new HttpRequest('POST', url, formData, { headers: headerOptions, reportProgress: true });
        this.http.request(req).subscribe((event: HttpEvent<any>) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.percentageProgress = Math.round(100 * event.loaded / event.total);

            console.log(`File is ${this.percentageProgress}% uploaded.`);
          } else if (event.type === HttpEventType.Response) {
            const body = event.body;
            result.fileName = body.hasOwnProperty('data') && body.data ? body.data.fileName : body.result.files.file[0].name;
            resolve(result);
          }
        }, err => {
          console.log('upload error', err)
          resolve(false);
        })
      }
    })
  }

  public onProgress = (progressEvent: ProgressEvent): void => {
    this.ngZone.run(() => {
      if (progressEvent.lengthComputable) {
        let progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
        if (progress > 100) progress = 100;
        if (progress < 0) progress = 0;
        this.percentageProgress = progress;
        console.log('native progress', this.percentageProgress);
      }
    });
  }

  async downloadFile(url: any, imageOriginalName: string) {
    var deviceIos = await this.platform.is('ios');
    if (deviceIos) {
      await this.permissionCheck.setPathDownload();
    }

    url = url + imageOriginalName;
    let fileName = this.createFilenameDatetime(imageOriginalName);

    console.log('url download', url);
    if (this.platform.is('cordova')) {
      let path = '';
      this.permissionCheck.setPathDownload().then(async () => {

        // for handle if fileName exp. imageName date blabla.jpg change to ImageName_date_blabla.jpg
        fileName = fileName.split(" ").join("_");

        // SET Storage path result download
        path = await this.storagePathProvider.setStorageNativeDownload(fileName);

        const fileTransfer: FileTransferObject = this.transfer.create();
        fileTransfer.download(url, path, true)
          .then((entry) => {
            console.log('success download', entry);
            let filePath: string = entry.toURL();
            let fileExtn = filePath.substring(filePath.lastIndexOf('.') + 1);
            let fileMIMEType = this.getMIMEtype(fileExtn);

            this.fileOpener.open(filePath, fileMIMEType).then(results => { }).catch(e => { });
            this.toastService.create('Successfully Download', 3000, 'bottom');
          }, (error) => {
            console.log('error download', error);
            this.toastService.create('Failed Download', 3000, 'bottom');
          });
      }).catch(error => {

        console.log('error download 2', error);
        this.toastService.create('Sorry, something went wrong', 3000, 'bottom');
      });
    }
    else {
      this.downloadFromWeb(url).subscribe(
        res => {
          saveAs(res, fileName);
        }, error => {
          this.toastService.create('Sorry, something went wrong', 3000, 'bottom');
        }
      );
    }
  }

  createFilenameDatetime(fileName) {
    const ext = fileName.substring(fileName.lastIndexOf('.'));
    const name = fileName.substring(0, fileName.lastIndexOf('.')) + '_' || '';
    console.log('TCL: filename', fileName);
    const dateTime = new Date().getTime().toString();
    return `${name + dateTime + ext}`; // exp : 21312409412412.jpg
  }

  downloadFromWeb(url: string) {
    return this.http.get(url, { responseType: 'blob' });
  }

  // for file opener
  getMIMEtype(extn) {
    let ext = extn.toLowerCase();
    let MIMETypes = {
      'txt': 'text/plain',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'doc': 'application/msword',
      'pdf': 'application/pdf',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'bmp': 'image/bmp',
      'png': 'image/png',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'rtf': 'application/rtf',
      'ppt': 'application/vnd.ms-powerpoint',
      'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'mp4': 'video/mp4'
    }
    return MIMETypes[ext];
  }

  getIPAddress() {
    return this.http.get<{ ip: string }>('https://jsonip.com');
  }

  presentLocalNotification(id: number = 1, title: string, msg: string) {
    /**
    * SHOW NOTIFICATION
    * Belum digunakan karena ada masalah di versi android 8.0.0 (Oreo)
    */
    this.localNotifications.schedule([{
      id: id,
      title: this.translate.instant(title),
      text: this.translate.instant(msg),
      icon: "res://drawable-hdpi/icon",
      smallIcon: "res://drawable-hdpi/icon",
    }]);
  }

  handleLocalNotification(): Promise<ILocalNotification> {
    return new Promise((resolve, reject) => {
      if (this.platform.is('cordova')) {
        this.localNotifications.on('click').subscribe(notification => {
          resolve(notification);
        });
      }
      else {
        reject(false)
      }
    })
  }

  handleErrorResponse(error: HttpErrorResponse) {
    if (error.status >= 500) {
      this.toastService.create('Sorry, something when wrong', 5000, 'bottom')
    }
    else {
      this.toastService.create(error.error.message, 5000, 'bottom')
    }
  }

  convertObjToCamelCase(obj = {}) {
    return new Promise((resolve) => {
      let newObj = {};
      for (let d in obj) {
        if (obj.hasOwnProperty(d)) {
          newObj[d.replace(/(\_\w)/g, (k) => {
            return k[1].toUpperCase();
          })] = obj[d];
        }
      }
      resolve(newObj);
    })
  }

  convertArrObjToCamelCase(data: Array<any> = []): Promise<Array<any>> {
    return new Promise(async (resolve) => {
      let temp = [];

      for (let value of data) {
        let newFormat = await this.convertObjToCamelCase(value);
        temp.push(newFormat);
      }

      resolve(temp);
    })
  }

  convertKeyArrObjFeed(arrData: Array<any>): Promise<Array<any>> {
    return new Promise((resolve) => {
      let tempDataArr = [];

      for (let objData of arrData) {
        objData.post = null;
        objData.request = null;
        objData.empOwner = null;
        objData.empReceiver = null;
        objData.alert = null;
        objData.newEmployee = null;
        objData.calendar = null;
        objData.smartFeed = null;

        if (objData.hasOwnProperty('rel_personal')) {
          objData.empOwner = objData.rel_personal;
          delete objData.rel_personal;
        }

        if (objData.hasOwnProperty('rel_post')) {
          objData.post = objData.rel_post;
          delete objData.rel_post;
        }

        if (objData.hasOwnProperty('rel_receiver')) {
          objData.empReceiver = objData.rel_receiver;
          delete objData.rel_receiver;
        }

        if (objData.hasOwnProperty('rel_request')) {
          objData.request = objData.rel_request;
          delete objData.rel_request;
        }

        if (objData.hasOwnProperty('rel_alert')) {
          objData.alert = objData.rel_alert;
          delete objData.rel_alert;
        }

        if (objData.hasOwnProperty('rel_new_employee')) {
          objData.newEmployee = objData.rel_new_employee;
          delete objData.rel_new_employee;
        }

        if (objData.hasOwnProperty('rel_calendar')) {
          objData.calendar = objData.rel_calendar;
          delete objData.rel_calendar;
        }

        if (objData.hasOwnProperty('rel_smartfeed')) {
          objData.smartFeed = objData.rel_smartfeed;
          delete objData.rel_smartfeed;
        }

        tempDataArr.push(objData);
      }
      resolve(tempDataArr);
    })
  }

  convertKeyObjFeed(objData): Promise<any> {
    return new Promise((resolve) => {

      if (objData.hasOwnProperty('rel_personal')) {
        objData.empOwner = objData.rel_personal;
        delete objData.rel_personal;
      }

      if (objData.hasOwnProperty('rel_post')) {
        objData.post = objData.rel_post;
        delete objData.rel_post;
      }

      if (objData.hasOwnProperty('rel_receiver')) {
        objData.empReceiver = objData.rel_receiver;
        delete objData.rel_receiver;
      }

      if (objData.hasOwnProperty('rel_request')) {
        objData.request = objData.rel_request;
        delete objData.rel_request;
      }

      if (objData.hasOwnProperty('rel_alert')) {
        objData.alert = objData.rel_alert;
        delete objData.rel_alert;
      }

      if (objData.hasOwnProperty('rel_new_employee')) {
        objData.newEmployee = objData.rel_new_employee;
        delete objData.rel_new_employee;
      }

      if (objData.hasOwnProperty('rel_calendar')) {
        objData.calendar = objData.rel_calendar;
        delete objData.rel_calendar;
      }

      if (objData.hasOwnProperty('rel_smartfeed')) {
        objData.smartFeed = objData.rel_smartfeed;
        delete objData.rel_smartfeed;
      }

      resolve(objData);
    })
  }

  getFilePath(uri: string) {
    let path = null;
    let filename = null;

    try {
      path = uri.substring(0, uri.lastIndexOf('/'));
      filename = uri.substring(uri.lastIndexOf('/') + 1);

      let idx = filename.indexOf('?');
      if (idx != -1) {
        filename = filename.substring(0, idx);
      }
    } catch (error) {
      console.log('TCL: error getFilePath', error);
    }

    return { path: path, filename: filename }
  }

  getPathAndFilename(url: string) {
    let fileName = url.substring(url.lastIndexOf('/') + 1);
    if (url.indexOf('?fileName=') != -1) {
      // handle storage nest js
      fileName = url.substring(url.lastIndexOf('=') + 1)
      url = url.substring(0, url.lastIndexOf('=') + 1);
    }
    else {
      // handle storage loopbaFk
      url = url.substring(0, url.lastIndexOf('/') + 1);
    }
    return { url: url, fileName: fileName }
  }

  async getImageBase62FromUrl(url: any) {
    var deviceIos = this.platform.is('ios');
    if (deviceIos) {
      await this.permissionCheck.setPathDownload();
    }
    const dataImage = this.getPathAndFilename(url);
    url = dataImage.url + dataImage.fileName;
    let fileName = this.createFilenameDatetime(dataImage.fileName);
    if (this.platform.is('cordova')) {
      try {
        await this.permissionCheck.setPathDownload();
        const path = await this.storagePathProvider.setStorageNativeDownload(fileName);
        const fileTransfer: FileTransferObject = this.transfer.create();
        const entry = await fileTransfer.download(url, path, true);
        const filePath: string = entry.toURL();
        const dataFile = this.getFilePath(filePath);
        return this.file.readAsDataURL(dataFile.path, dataFile.filename);
      } catch (error) {
        throw error;
      }
    }
  }

  setIsGooglePlayServicesAvailable(value: boolean) {
    this.isGooglePlayServicesAvailable = value;
  }

  getIsGooglePlayServicesAvailable() {
    return this.isGooglePlayServicesAvailable;
  }

  setIsGoogleMapsAvailable(value: boolean) {
    this.isGoogleMapsAvailable = value;
  }

  getIsGoogleMapsAvailable() {
    return this.isGoogleMapsAvailable;
  }

  // Gunakan event (keypress) pada ion-input / input
  inputNumberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  checkTypeAttachment(fileName: string) {
    let formatImage = fileName.substring(fileName.lastIndexOf('.') + 1);
    let res = formatImage.toLowerCase();

    if (res == 'jpg' || res == 'jpeg' || res == 'png' || res == 'svg' || res == 'gif') {
      return 'image';
    } else {
      return 'file';
    }
  }

  async getFormatNameDateTime(): Promise<{
    monthNames: any,
    monthShortNames: any,
    dayNames: any,
    dayShortNames: any,
    doneText: string,
    cancelText: string
  }> {
    // const dataMonth = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    // const dataMonthShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    // const dataDay = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
    // const dataDayShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

    const lang = await this.storage.get('language');
    const data = this.languageList.filter(params => { return params.value == lang });
    moment.locale(data[0].locale);
    const dataMonth = moment.months();
    const dataMonthShort = moment.monthsShort();
    const dataDay = moment.weekdays();
    const dataDayShort = moment.weekdaysShort();
    const _monthNames = [];
    for (const item of dataMonth) {
      _monthNames.push(item);
    }
    const _monthShortNames = [];
    for (const item of dataMonthShort) {
      _monthShortNames.push(item);
    }
    const _dayNames = [];
    for (const item of dataDay) {
      _dayNames.push(item);
    }
    const _dayShortNames = [];
    for (const item of dataDayShort) {
      _dayShortNames.push(item);
    }
    const doneText = this.translate.instant('Done');
    const cancelText = this.translate.instant('Cancel');
    return {
      monthNames: _monthNames,
      monthShortNames: _monthShortNames,
      dayNames: _dayShortNames,
      dayShortNames: _dayShortNames,
      doneText: doneText,
      cancelText: cancelText
    };
  }

  async getLocaleMoment(): Promise<any> {
    try {
      const lang = await this.storage.get('language');
      const data = this.languageList.filter(params => { return params.value == lang });
      return data[0].locale;
    } catch (error) {
      return 'en';
    }
  }

  /**
  * ALERT FOR REDIRECT UPDATE TO PLAYSTORE OR APPSTORE
  * @param enableBack
  */
  showConfirmUpdateApps(isForceUpdate: any, message = 'Please update app to get the latest features, improvements, and bug fixes') {
    // let status: boolean = enableBack;
    let url = "https://play.google.com/store/apps/details?id=com.dataon.sunfishgo";
    if (this.platform.is("ios")) {
      url = "https://itunes.apple.com/id/app/greatday-hr-sunfish-go/id1149720670?l=id&mt=8";
    }

    const alert = this.alertCtrl.create({
      title: this.translate.instant(Messages.INFORMATION),
      message: message ? this.translate.instant(message) : '',
      enableBackdropDismiss: false
    });

    if (!isForceUpdate) {
      alert.addButton({
        text: this.translate.instant('Skip'),
        handler: () => {
          alert.dismiss();
        }
      })
    }

    alert.addButton({
      text: this.translate.instant('Update Now'),
      handler: () => {
        this.inAppBrowser.create(url, '_system');
        this.platform.exitApp();
      }
    });

    if (isForceUpdate) {
      this.platform.backButton.subscribe(() => {
        this.platform.exitApp();
      })
    }
    alert.present();
  }

  downloadFromInAppBrowser(message: any) {
    window.parent.postMessage(message, '*');
  }

}



// WEBPACK FOOTER //
// ./src/providers/global-service/global-service.ts